import { customElement, property, state } from "lit/decorators.js";
import { css, html, LitElement, nothing } from "lit";
import { addGlobalStylesToShadowRoot } from "../../util/globalStyleSheetsUtil";

@customElement("ehm-reveal")
export class Reveal extends LitElement {
  static styles = css`
    :host {
      display: block;
    }
    button {
      margin: 1.25rem auto 0;
      appearance: none;
      border: none;
      background: none;
      cursor: pointer;
      font: var(--font-text-md);
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: var(--text-semibold);
      --icon-rotate: 90deg;
      --icon-size: 1rem;
      color: var(--text-primary);
      text-decoration: underline;
      text-underline-offset: 0.25rem;
    }
    button:hover {
      text-decoration: none;
    }
    button:focus-visible,
    button:active {
      outline: var(--outline);
      outline-offset: var(--outline-offset);
      border-radius: var(--radius-md);
      text-decoration: none;
    }
  `;

  @property({ type: Number, attribute: "items-per-reveal" })
  itemsPerPage = 2;

  @property({ type: Number, attribute: "items-per-reveal-mobile" })
  itemsPerPageMobile = 2;

  @property({ type: String, attribute: "reveal-text" })
  revealText = "Visa fler";

  @property({ type: Boolean }) showall = false;
  @property({ type: Boolean }) noicon = false;

  @state() private visibleItems = 0;
  @state() private currentItemsPerPage = 0;

  #items: NodeListOf<RevealItem>;
  #mediaQuery = window.matchMedia("(max-width: 768px)");

  constructor() {
    super();
    this.#items = this.querySelectorAll("ehm-reveal-item");
  }

  firstUpdated() {
    this.#mediaQuery.addEventListener("change", () => this.#updateItemsPerPage());
    if (this.#mediaQuery.matches) {
    }
    this.#updateItemsPerPage();
    // addGlobalStylesToShadowRoot(this.shadowRoot!);
  }

  #updateItemsPerPage() {
    const isSmallViewport = this.#mediaQuery.matches;
    if (isSmallViewport) {
      this.currentItemsPerPage = this.itemsPerPageMobile;
    } else {
      this.currentItemsPerPage = this.itemsPerPage;
    }
    this.visibleItems = this.currentItemsPerPage;

    this.#updateVisibility();
  }

  #updateVisibility() {
    this.#items.forEach((item, index) => {
      if (index < this.visibleItems) {
        item.style.display = "block";
      } else {
        item.style.display = "none";
      }
    });
  }

  #revealMore() {
    if (this.showall) {
      this.visibleItems = this.#items.length;
    } else {
      this.visibleItems += this.currentItemsPerPage;
    }

    this.#updateVisibility();
  }

  render() {
    const hasMoreItems = this.visibleItems < this.#items.length;

    return html`
      <div id="items" part="items" aria-live="polite">
        <slot></slot>
      </div>
      ${hasMoreItems
        ? html`
          <button
            part="button"
            aria-controls="items"
            aria-live="polite"
            @click="${this.#revealMore}"
          >
            ${this.revealText}
            ${!this.noicon ? html`
              <ehm-icon name="caret"></ehm-icon>` : html``}
          </button>
        `
        : nothing}
    `;
  }
}

@customElement("ehm-reveal-item")
class RevealItem extends LitElement {
  render() {
    return html`
      <slot></slot>`;
  }
}
